import * as React from 'react';
import { IconProps } from '../types';

const IcCalendar = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M5 4.5A1.5 1.5 0 0 0 3.5 6v13.5A1.5 1.5 0 0 0 5 21h15a1.5 1.5 0 0 0 1.5-1.5V6A1.5 1.5 0 0 0 20 4.5H5ZM2 6a3 3 0 0 1 3-3h15a3 3 0 0 1 3 3v13.5a3 3 0 0 1-3 3H5a3 3 0 0 1-3-3V6Z"
      clipRule="evenodd"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M14.375 12a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM18.125 12a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM14.375 15.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM18.125 15.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM6.875 15.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM10.625 15.75a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM6.875 19.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM10.625 19.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25ZM14.375 19.5a1.125 1.125 0 1 0 0-2.25 1.125 1.125 0 0 0 0 2.25Z"
    />
    <path
      fill={props?.fill ?? '#232F3E'}
      fillRule="evenodd"
      d="M6.5 1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75ZM18.5 1.5a.75.75 0 0 1 .75.75v1.5a.75.75 0 0 1-1.5 0v-1.5a.75.75 0 0 1 .75-.75ZM2.75 6.75h19.5v1.5H2.75v-1.5Z"
      clipRule="evenodd"
    />
  </svg>
);

export default IcCalendar;